import client from "api/client";

const PATHS = {
  GET_SUBHEADINGS: "/subheadings?populate=*",
};

export const getSubheadings = async (config) => {
  return await client.get(PATHS.GET_SUBHEADINGS, config);
};
